/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from "styled-components";
import { PropTypes } from "prop-types";
import {
  forthMixin,
  grayTextMixin,
  noBorderPrimaryMixin,
  outlinePrimaryMixin,
  primaryMixin,
  secundaryMixin,
  smallMixin,
  thirdMixin,
} from "./styles";
import { FiraSansBold } from "../Text";
import { Breakpoints } from "../../constants/Breakpoints";
import Colors from "../../constants/Colors";

const propTypes = {
  outlinePrimary: PropTypes.bool,
  type: PropTypes.string,
};

const defaultProps = {
  outlinePrimary: false,
  type: "button",
};

const Button = styled.button`
  padding: 0.1rem 0.2rem;
  width: auto;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  font-size: 15px;
  height: 42px;
  white-space: nowrap;
  margin: 0px 0px 0px 0px;
  width: 180px;

  ${FiraSansBold};

  border: 0 none;
  border-radius: 8px;
  background: transparent;

  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, width 0.3s ease,
    border 0.5s ease, border-color 0.5s ease, box-shadow 0.15s ease;

  text-align: center;
  &:focus,
  &:active {
    outline: none;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  ${({ outlinePrimary }) => outlinePrimary && outlinePrimaryMixin}
  ${({ text }) => text && grayTextMixin}
  ${({ primary }) => primary && primaryMixin}
  ${({ secundary }) => secundary && secundaryMixin}
  ${({ third }) => third && thirdMixin}
  ${({ noBorderPrimary }) => noBorderPrimary && noBorderPrimaryMixin}
  ${({ forth }) => forth && forthMixin}
  ${({ sm }) => sm && smallMixin}
  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}

`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 0px 0px 0px;

  @media (max-width: ${Breakpoints.lg}) {
    flex-wrap: wrap;
  }
`;

export const ButtonContent = styled.div`
  display: flex;
  flex-direction: auto;
  background-color: ${Colors.WHITE};
`;

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
